// extracted by mini-css-extract-plugin
module.exports = {"root":"ItemViewerList_root__1V9Dn","item_viewer":"ItemViewerList_item_viewer__3R0t4","item_viewer_label":"ItemViewerList_item_viewer_label__3K5c0"};